module.exports = __webpack_public_path__ + "static/img/other3.5c5e138.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other3.png
// module id = phKW
// module chunks = 1